// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YfLAq","icon":"styles_icon__3xQzF"};